import React from "react";
import "./Style/common.css";
import "./Style/Timeout.css";

// Optional Loading component to replace <UC:LoadingScreen />
import Loading from "../Common/Loading"; 

const Timeout: React.FC = () => {
  const handleCloseMessage = () => {
    // Example: redirect to login page
    localStorage.clear();
    sessionStorage.clear();
    
    window.location.href = "/";
  };

  return (
    
    <div id="timed_out">

      <div id="timed_out_image"></div>
      <p>
        <span className="title_text">Session timed out</span>
        <span id="ar_text" className="state_text">
          You have been logged out due to inactivity. Log in again to resume your progress.
        </span>
      </p>
      <div id="to_close_btn" className="general_btn two_btn" onClick={handleCloseMessage}>
        <p  style={{marginTop:'30px'}}>
          Close Message
        </p>
      </div>

      {/* Loading overlay */}
      {/* <Loading /> */}
    </div>
  );
};

export default Timeout;



